import React from 'react';
import PropTypes from 'prop-types';
import { Stack, Typography } from '@mui/material';
import ConfigCard from './ConfigCard';
import { CheckboxTile } from './_PdiHelpers';

// What search engines get as structured data on the product page (the bot
// version, server/v1/prerender.php). Both switches are per shop and off by
// default (mig207), so a shop only changes when it turns one on:
//   - breadcrumbSchema → SEO_BREADCRUMB_SCHEMA: the category trail as
//     BreadcrumbList, so Google can show it instead of the URL
//   - productVariants  → SEO_PRODUCT_VARIANTS: the sizes as variants, so
//     every offer says which size it is
const SeoSchemaCard = ({ value = {}, onChange, theme, t }) => {
    const tr = (key, fallback) => (typeof t === 'function' ? t(key) : fallback);
    const set = (field) => (v) => onChange && onChange(field, v);
    const help = (text) => (
        <Typography variant="caption" sx={{ display: 'block', color: 'text.secondary', mt: 0.5, mb: 0.5, lineHeight: 1.4 }}>
            {text}
        </Typography>
    );

    return (
        <ConfigCard
            anchor="cfg-card-pdi-seo"
            title={tr('cfg_pdi_seo_title', 'Search results (Google)')}
            description={tr('cfg_pdi_seo_desc', 'Extra product information for search engines. Visitors see no difference.')}
            theme={theme}
        >
            <Stack spacing={1.5}>
                <div>
                    <CheckboxTile
                        label={tr('cfg_pdi_seo_breadcrumb', 'Pass the category breadcrumb to Google')}
                        checked={!!value.breadcrumbSchema}
                        onChange={set('breadcrumbSchema')}
                    />
                    {help(tr('cfg_pdi_seo_breadcrumb_help', 'Google can then show the categories (e.g. Men › Polo) in the search results instead of the web address. Uses the levels of the category breadcrumb.'))}
                </div>
                <div>
                    <CheckboxTile
                        label={tr('cfg_pdi_seo_variants', 'Pass sizes to Google as variants')}
                        checked={!!value.productVariants}
                        onChange={set('productVariants')}
                    />
                    {help(tr('cfg_pdi_seo_variants_help', 'Every size gets its own price and availability for Google, with the size named. Without this, Google sees one offer per size without knowing which size it is.'))}
                </div>
            </Stack>
        </ConfigCard>
    );
};

SeoSchemaCard.propTypes = {
    value:    PropTypes.object,
    onChange: PropTypes.func,
    theme:    PropTypes.string,
    t:        PropTypes.func,
};

export default SeoSchemaCard;
